export class Language {
  constructor(
    public readonly displayName: string,
    // ISO 639-1
    public readonly iso6391: string,
  ) {}
}
